import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from 'sonner';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import OrderSuccess from './pages/OrderSuccess';
import About from './pages/About';
import Contact from './pages/Contact';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminOverview from './pages/admin/AdminOverview';
import AdminProducts from './pages/admin/AdminProducts';
import AdminCategories from './pages/admin/AdminCategories';
import AdminOrders from './pages/admin/AdminOrders';
import AdminReviews from './pages/admin/AdminReviews';
import AdminBanners from './pages/admin/AdminBanners';
import AdminHomepageSections from './pages/admin/AdminHomepageSections';
import AdminHomepageReviews from './pages/admin/AdminHomepageReviews';
import AdminNewsletter from './pages/admin/AdminNewsletter';
import AdminReturns from './pages/admin/AdminReturns';
import AdminCustomers from './pages/admin/AdminCustomers';
// Marketing System - Phase 4
import AdminMarketing from './pages/admin/AdminMarketing';
import AdminCoupons from './pages/admin/AdminCoupons';
import AdminFlashSales from './pages/admin/AdminFlashSales';
import AdminBundleOffers from './pages/admin/AdminBundleOffers';
import AdminFestivalCampaigns from './pages/admin/AdminFestivalCampaigns';
// Analytics - Phase 5
import AdminReports from './pages/admin/AdminReports';
import AdminInventory from './pages/admin/AdminInventory';
import AdminInventorySync from './pages/admin/AdminInventorySync';
import AdminSEO from './pages/admin/AdminSEO';
import AdminSettings from './pages/admin/AdminSettings';
// Customer Account Dashboard
import AccountDashboard from './pages/account/AccountDashboard';
import AccountOverview from './pages/account/AccountOverview';
import AccountOrders from './pages/account/AccountOrders';
import AccountOrderDetail from './pages/account/AccountOrderDetail';
import AccountWishlist from './pages/account/AccountWishlist';
import AccountAddresses from './pages/account/AccountAddresses';
import AccountProfile from './pages/account/AccountProfile';
import AccountReturnsPage from './pages/account/AccountReturns';
import Wishlist from './pages/Wishlist';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          
          <Route path="/admin/*" element={<AdminDashboard />}>
            <Route path="dashboard" element={<AdminOverview />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="orders" element={<AdminOrders />} />
            <Route path="reviews" element={<AdminReviews />} />
            <Route path="banners" element={<AdminBanners />} />
            <Route path="homepage-sections" element={<AdminHomepageSections />} />
            <Route path="homepage-reviews" element={<AdminHomepageReviews />} />
            <Route path="newsletter" element={<AdminNewsletter />} />
            <Route path="returns" element={<AdminReturns />} />
            <Route path="customers" element={<AdminCustomers />} />
            <Route path="marketing" element={<AdminMarketing />} />
            <Route path="coupons" element={<AdminCoupons />} />
            <Route path="flash-sales" element={<AdminFlashSales />} />
            <Route path="bundle-offers" element={<AdminBundleOffers />} />
            <Route path="festival-campaigns" element={<AdminFestivalCampaigns />} />
            <Route path="reports" element={<AdminReports />} />
            <Route path="inventory" element={<AdminInventory />} />
            <Route path="inventory-sync" element={<AdminInventorySync />} />
            <Route path="seo" element={<AdminSEO />} />
            <Route path="media" element={<div className="p-8 text-center text-charcoal-light">Media library coming soon</div>} />
            <Route path="settings" element={<AdminSettings />} />
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
          </Route>

          <Route path="*" element={
            <>
              <Navbar />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/products" element={<Products />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/order-success/:orderId" element={<OrderSuccess />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/wishlist" element={<Wishlist />} />
                
                {/* Customer Account Dashboard */}
                <Route path="/account" element={<AccountDashboard />}>
                  <Route index element={<AccountOverview />} />
                  <Route path="orders" element={<AccountOrders />} />
                  <Route path="orders/:orderId" element={<AccountOrderDetail />} />
                  <Route path="wishlist" element={<AccountWishlist />} />
                  <Route path="addresses" element={<AccountAddresses />} />
                  <Route path="profile" element={<AccountProfile />} />
                  <Route path="returns" element={<AccountReturnsPage />} />
                </Route>
              </Routes>
              <Footer />
              <WhatsAppButton />
            </>
          } />
        </Routes>
        <Toaster position="top-right" theme="dark" />
      </BrowserRouter>
    </div>
  );
}

export default App;
